import {mapMutations} from "vuex";

export default {
    created() {
        this.resetTitle()
    },
    methods: {
        ...mapMutations('title', [
            'resetTitle'
        ]),
    }
}
